module.exports = __webpack_public_path__ + "static/media/SVID_Z_4.fe0bfdb8.png";